import { render } from "./PerfilAdmin.vue?vue&type=template&id=748d8be0&scoped=true"
import script from "./PerfilAdmin.vue?vue&type=script&lang=js"
export * from "./PerfilAdmin.vue?vue&type=script&lang=js"

import "./PerfilAdmin.vue?vue&type=style&index=0&id=748d8be0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748d8be0"]])

export default __exports__